<template>
<div class="reportNameList padding-20 bgc box-shadow">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleExport">导出名单</el-button>
        </div>
        <div class="search">
            <el-input v-model="param.customername" placeholder="请输入姓名" class="condition"></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="mobileno" label="手机号"></el-table-column>
            <el-table-column prop="email" label="邮箱"></el-table-column>
            <el-table-column prop="datetime" label="购买时间"></el-table-column>
            <el-table-column prop="finalpaymoney" label="购买价格">
                <template slot-scope="scope">
                    <span class="tc-red">{{scope.row.finalpaymoney}}</span>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
</div>
</template>

<script>
import Page from 'base/page/page'
import {getReportNameList, exportReportNameList} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'reportNameList',
    data() {
        return {
            total: 550,
            param: {
                reportinnerid: this.$route.query.id ? this.$route.query.id : '', // id
                customername: ''
            },
            tableData: []
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        handleExport() {
            this.setLoading(true)
            exportReportNameList({
                data: Object.assign({}, this.param),
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '报告名单' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getReportNameList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.reportNameList {
    .result-list{
        .el-table__row{
            height: 100px;
        }
    }
}
</style>
